module.exports = __webpack_public_path__ + "static/media/taylors.f337890f.jpg";